import { selector, selectorFamily } from "recoil";
import {
  Agency,
  CookieTemplates,
  Document,
  Faq,
  FileFormat,
  Fractionation,
  Logo,
  Message,
  Optional,
} from "src/types";

import { atomDossier, atomDossierConfig } from "./data.atoms";

export const selectorAgency = selector<Optional<Agency>>({
  key: "agency",
  get: ({ get }) => get(atomDossier)?.agenzia,
});

export const selectorDocuments = selector<Optional<Document[]>>({
  key: "documents",
  get: ({ get }) => {
    let updateDocuments: Document[] = [];

    let documents: Document[] =
      get(atomDossier)?.prodotti?.[0]?.documenti || [];
    const agencyDocuments = get(selectorAgency)?.documents || [];

    if (agencyDocuments?.length > 0) {
      agencyDocuments?.map((agencyDocument) => {
        documents = replaceDocument(agencyDocument, documents);
      });
    }

    updateDocuments = [...documents]?.sort(
      (document1, document2) =>
        Number(document1?.docCode) - Number(document2?.docCode)
    );

    return updateDocuments;
  },
});

const replaceDocument = (
  newDocument: Document,
  documents: Document[]
): Document[] => {
  const filteredDocuments =
    documents?.filter(
      (document) => document?.docCode !== newDocument?.docCode
    ) || [];
  filteredDocuments?.push(newDocument);
  return filteredDocuments || [];
};

export const selectorLogos = selectorFamily<Optional<Logo[]>, FileFormat>({
  key: "logos",
  get:
    (fileFormat: FileFormat) =>
    ({ get }) => {
      const dossierConfig = get(atomDossierConfig);

      return dossierConfig?.configurazioni.loghi.filter((logo) =>
        logo.docCode.includes(fileFormat)
      );
    },
});

export const selectorFaqs = selector<Optional<Faq[]>>({
  key: "faqs",
  get: ({ get }) => get(atomDossier)?.prodotti?.[0]?.faq,
});

export const selectorFractionations = selectorFamily<
  Optional<Fractionation[]>,
  string
>({
  key: "fractionations",
  get:
    (codProd: string) =>
    ({ get }) => {
      const products = get(atomDossier)?.prodotti;
      return products?.find((product) => product.prodotto.code === codProd)
        ?.frazionamenti;
    },
});

export const selectorDocumentsGroup = selector<Optional<Document[]>>({
  key: "documentsGroup",
  get: ({ get }) => {
    const dossierConfig = get(atomDossierConfig);

    return dossierConfig?.configurazioni.documentiGruppi || [];
  },
});

export const selectorCookieTemplate = selector<Optional<CookieTemplates>>({
  key: "cookieTemplates",
  get: ({ get }) => {
    const dossierConfig = get(atomDossierConfig);

    return dossierConfig?.configurazioni?.cookiesTemplate;
  },
});

export const selectorWebPolicyDocument = selector<Optional<Message>>({
  key: "webPolicy",
  get: ({ get }) => {
    const dossierConfig = get(atomDossierConfig);

    return dossierConfig?.configurazioni?.informativaWeb;
  },
});
